import { useEffect, useState, useContext } from "react";
import { useToastAction } from "../../hooks/useToastAction";
import { getViewpointPdf } from "../../api/webEditor";
import { setApiKey } from "../../api/api";
import { MetaforceContext } from "../../contexts";
import * as Constants from "../../utils/constants";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../translations/translationsConstants";
import { config } from "../../utils/config";

export const LocalprintViewpointPdf = () => {
    const { startParameter } = useContext(MetaforceContext);
    const [blobUrl, setBlobUrl] = useState();
    const { t: terr } = useTranslation([resources.errors]);

    setApiKey();

    const loadAction = useToastAction();

    const loadData = async () => {
        loadAction.execute(async () => {
            const res = await getViewpointPdf(startParameter);
            const blob = new Blob([res], { type: "application/pdf" });
            const newBlobUrl = URL.createObjectURL(blob);
            setBlobUrl(newBlobUrl);
        }, terr(translations.errors.failLoadFile));
    }

    useEffect(() => {
        loadData()
    }, []);

    if (config.usePdfPreviewModal) {
        return (
            <main className="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
                <div className="tw-text-center tw-p-8">
                    <h2 className="tw-text-lg tw-font-medium tw-text-gray-900 tw-mb-2">PDF Preview</h2>
                    <p className="tw-text-sm tw-text-gray-500">The PDF will be shown in a modal on the original page.</p>
                </div>
            </main>
        );
    }

    return !loadAction.isExecuting && (
        <main className="tw-h-full tw-w-full">
            {blobUrl && <iframe width='100%' height='100%' src={blobUrl} />}
        </main>
    )
}